import request from '@/router/axios'

export function fetchList (query) {
  return request({
    url: `/post/admin/complaint/${query.handleResult === '0' ? 'unaudited' : 'audited'}/page`,
    method: 'get',
    params: query
  })
}

export function ignoreObj (handleMsg) {
  return request({
    url: '/post/admin/complaint/ignore',
    method: 'put',
    data: handleMsg
  })
}

export function banObj (handleMsg) {
  return request({
    url: '/post/admin/complaint/ban',
    method: 'put',
    data: handleMsg
  })
}

export function waitObj (handleMsg) {
  return request({
    url: '/post/admin/complaint/wait',
    method: 'put',
    data: handleMsg
  })
}

export function getAllCategoryList () {
  return request({
    url: '/admin/admin/complaint-category',
    method: 'get',
  })
}

export function getAttachment (id) {
  return request({
    url: '/post/admin/complaint/attachment/' + id,
    method: 'get',
  })
}